import {SanityTSDocConfigOptions} from './types'

/** @public */
export function defineConfig(config: SanityTSDocConfigOptions): SanityTSDocConfigOptions {
  return config
}
